const constants = {
    h1_max: 65,
    h1_min: 30,

    h2_max: 35,
    h2_min: 27,

    h3_max: 25,
    h3_min: 20,
    //font-size: clamp(19px, 2vw, 21px);
    p_max: 20,
    p_min: 17,

    duration_itemAnim: 1,
    headerAnim: 1,
    secondAnim: 1.5,
    thirdAnim: 1,
    headerSize: 70,

    transitionButton: 0.4,

    // BORDER RADIUS
    borderRadius1: 10,
    // COLOR
    colorLightGreen: "#3afbbd",
    colorDarkGreen: "#0b755c",

    // FILTER COLOR
    colorLightGreenFilter: "invert(100%) sepia(31%) saturate(4578%) hue-rotate(77deg) brightness(106%) contrast(97%)",
    colorDarkGreenFilter: "invert(34%) sepia(15%) saturate(2951%) hue-rotate(121deg) brightness(94%) contrast(91%)",
    colorWhiteFilter: "invert(85%) sepia(12%) saturate(508%) hue-rotate(167deg) brightness(123%) contrast(96%)",
    colorDarkFilter: "invert(14%) sepia(63%) saturate(182%) hue-rotate(172deg) brightness(96%) contrast(90%)",

    colorLight1: "#cecfdf",
    colorLight2: "#a9aab5",
    colorDark1: "#293038",
    colorDark2: "#1a242a",

    //FONT SIZE
    fontSize1: "25px",
    fontSize2: "23px",
    fontSize3: "20px",
    fontSize4: "18px",
    fontSize5: "15px",

    // BOX SHADOW
    boxShadow: "0 3px 6px rgba(0,0,0,0.16),0 3px 6px rgba(0,0,0,0.23)",

    //WIDTH TOGGLE BUTTON MENU
    maxWindowWidthForSideMenuButton: 770,
}
export default constants